import React, { useState, useEffect } from 'react';
import styles from './ExpectationsContent.scss';
import classnames from 'classnames';
import { Fragment } from 'react';
import lodash from 'lodash';
import SaveFixedFooter from 'pages/studyOverview/components/SaveFixedFooter';
import { ExpectationCard } from './common/ExpectationCard';
import {
    hasSelectedItem,
    isAllSelected,
    isChecked,
    toggleSingleCheckbox,
} from './common/helperFunctions';

export default function Study(props) {

    const { removeStudyExpectations, studyDocuments } = props;
    const allStudyExpectationIds = lodash.map(studyDocuments, expectation => expectation.id);

    const [toDelete, setToDelete] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const isPartiallySelected = hasSelectedItem(studyDocuments, toDelete);

    useEffect(() => {
        if (selectAll) {
            setToDelete((toDelete) =>
                isPartiallySelected ?
                    [] 
                    :lodash.uniq([...toDelete, ...allStudyExpectationIds])
            );
        } else {
            !isPartiallySelected && setToDelete([]);
        }
    }, [selectAll]);

    useEffect(() => {
        const selectedAll = isAllSelected(studyDocuments, toDelete);
        if (selectedAll) {
            setSelectAll(true);
        } else if (isPartiallySelected || lodash.isEmpty(toDelete)) {
            setSelectAll(false);
        }
    }, [toDelete]);

    return (
        <Fragment data-cy="Study">
            <div className={styles.container} data-cy="Study-div">
                {
                    !lodash.isEmpty(studyDocuments) ?
                        <ListStudyExpectations
                            selectAll={selectAll}
                            setSelectAll={setSelectAll}
                            partiallySelected={isPartiallySelected}
                            studyDocuments={studyDocuments}
                            toDelete={toDelete}
                            setToDelete={setToDelete}
                        /> :
                        <p>No study expectations available. Go to expectations tab to get started.</p>
                }
            </div>
            <SaveFixedFooter
                disabled={lodash.isEmpty(toDelete)}
                onClick={() => {
                    removeStudyExpectations(toDelete),
                    setToDelete([]);
                }}
                data-cy="Study-Remove"
            >
                Remove
            </SaveFixedFooter>
        </Fragment>

    );
}

export const SelectAllExpectations = ({
    selectAll,
    setSelectAll,
    partiallySelected
}) => (
    <div className={classnames(
        styles.selectAll,
        { [styles.checked]: selectAll }
    )}>
        <input
            name={'all'}
            type="checkbox"
            checked={selectAll}
            onChange={() => setSelectAll(selectAll => !selectAll)}
            ref={el => el && (el.indeterminate = partiallySelected)}
        />
        <span>Select All</span>
    </div>
);

export const ListStudyExpectations = ({
    selectAll, 
    setSelectAll, 
    partiallySelected, 
    studyDocuments, 
    toDelete, 
    setToDelete
}) => {

    return (
        <div className={styles.expectationList}>
            <SelectAllExpectations
                selectAll={selectAll} 
                setSelectAll={setSelectAll}
                partiallySelected={partiallySelected}
            />
            {!lodash.isEmpty(studyDocuments) &&
                (studyDocuments).map(expectation => (
                    <div className={styles.listItem}>
                        <ExpectationCard label={expectation.name}
                            checked={isChecked(expectation.id, toDelete)}
                        >
                            <input
                                name={expectation.name}
                                type="checkbox"
                                checked={isChecked(expectation.id, toDelete)}
                                onChange={() => setToDelete(toDelete => toggleSingleCheckbox(expectation.id, toDelete))}
                            />
                        </ExpectationCard>
                    </div>
                ))
            }
        </div>
    );
};
